import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SocialMarketPairState } from "./types";
import { fetchPair, fetchPairChart, fetchPairGlass } from "./social-market-pair-thunk";
import { ErrorType } from "@/shared/types";

const initialState: SocialMarketPairState = {
    pair: {
        bonus1_id: "",
        bonus2_id: "",
        description: "",
        fee: 0,
        current_sell_quantity: 0,
        id: "",
        is_active: false,
        min_fee: 0,
        name: "",
        price: 0
    },
    pairError: null,
    isPairLoading: false,

    cursor: 0,
    chart: [],
    isChartLoading: false,
    chartError: null,
    chartInterval: 600,
    chartCount: 30,

    glass: {
        last_deal_price: 0,
        sell: [],
        buy: []
    },
    isGlassLoading: false,
    isGlassFirstLoad: false,
    glassError: null,
}

const socialMarketPair = createSlice({
    name: 'socialMarketPair',
    initialState,
    reducers: {
        setChartInterval: (state, action: PayloadAction<number>) => {
            state.chartInterval = action.payload
        },
        setChartCount: (state, action: PayloadAction<number>) => {
            state.chartCount = action.payload
        },
    },
    extraReducers(builder) {
        builder
        .addCase(fetchPair.pending, (state) => {
            state.isPairLoading = true
            state.glass = {
                last_deal_price: 0,
                sell: [],
                buy: []
            }
            state.chart = []
        })
        .addCase(fetchPair.fulfilled, (state, action) => {
            state.pair = action.payload
            state.isPairLoading = false
            state.pairError = null
        })
        .addCase(fetchPair.rejected, (state, action) => {
            state.pairError = action.payload as ErrorType ?? null
            state.isPairLoading = false
        })
        .addCase(fetchPairGlass.pending, (state) => {
            state.isGlassLoading = false
        })
        .addCase(fetchPairGlass.fulfilled, (state, action) => {
            state.isGlassFirstLoad = true
            state.glassError = null
            state.glass = action.payload
            state.isGlassLoading = false
        })
        .addCase(fetchPairGlass.rejected, (state, action) => {
            state.glassError = action.payload as ErrorType ?? null
            state.isGlassLoading = false
        })
        .addCase(fetchPairChart.pending, (state) => {
            state.isChartLoading = false
        })
        .addCase(fetchPairChart.fulfilled, (state, action) => {
            state.chartError = null
            state.chart = action.payload.items
            state.isChartLoading = false
        })
        .addCase(fetchPairChart.rejected, (state, action) => {
            state.chartError = action.payload as ErrorType ?? null
            state.isChartLoading = false
        })
    },
})

export const { setChartInterval, setChartCount } = socialMarketPair.actions

export default socialMarketPair.reducer